"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tvl = exports.withdrawBuilder = exports.withdraw = exports.deposit = exports.refreshReserveIx = exports.setHashes = exports.initializeProtocol = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const buffer_layout_1 = __importDefault(require("buffer-layout"));
const sha256_uint8array_1 = require("sha256-uint8array");
const addressParser_1 = require("../addressParser");
const protocols_1 = require("../protocols");
const solendKeysAll = (0, addressParser_1.addressParser)({
    group: "protocols",
    name: "solend",
});
const refreshReserve = 3;
function initializeProtocol(program) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const solendKeys = solendKeysAll[tokenInput];
        const vaultSolendCollateralTokenAccount = yield (0, spl_token_1.getAssociatedTokenAddress)(solendKeys.reserveCollateralSplTokenMint, vaultKeys.vaultAccount, true);
        vaultKeys.vaultSolendCollateralTokenAccount =
            vaultSolendCollateralTokenAccount;
        if (yield program.connection.getAccountInfo(vaultSolendCollateralTokenAccount)) {
            console.log("solend accounts already initialized");
            return null;
        }
        else {
            const tx = new anchor_1.web3.Transaction();
            tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(program.user, vaultSolendCollateralTokenAccount, vaultKeys.vaultAccount, solendKeys.reserveCollateralSplTokenMint));
            return tx;
        }
    });
}
exports.initializeProtocol = initializeProtocol;
function setHashes(program) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const solendKeys = solendKeysAll[tokenInput];
        const depositData = new Uint8Array([
            ...vaultKeys.vaultSolendCollateralTokenAccount.toBytes(),
            ...solendKeys.reserveAccount.toBytes(),
            ...solendKeys.reserveLiquiditySupplySplTokenAccount.toBytes(),
            ...solendKeys.reserveCollateralSplTokenMint.toBytes(),
            ...solendKeys.lendingMarketAccount.toBytes(),
            ...solendKeys.derivedLendingMarketAuthority.toBytes(),
        ]);
        const withdrawData = new Uint8Array([
            ...vaultKeys.vaultSolendCollateralTokenAccount.toBytes(),
            ...solendKeys.reserveAccount.toBytes(),
            ...solendKeys.lendingMarketAccount.toBytes(),
            ...solendKeys.derivedLendingMarketAuthority.toBytes(),
            ...solendKeys.reserveCollateralSplTokenMint.toBytes(),
            ...solendKeys.reserveLiquiditySupplySplTokenAccount.toBytes(),
        ]);
        const tvlData = new Uint8Array([
            ...solendKeys.reserveAccount.toBytes(),
            ...vaultKeys.vaultSolendCollateralTokenAccount.toBytes(),
        ]);
        const HASH_LEN = 16;
        const hashes = [
            (0, sha256_uint8array_1.createHash)().update(depositData).digest().slice(0, HASH_LEN),
            (0, sha256_uint8array_1.createHash)().update(withdrawData).digest().slice(0, HASH_LEN),
            (0, sha256_uint8array_1.createHash)().update(tvlData).digest().slice(0, HASH_LEN),
        ];
        return program.methods
            .setHashes(protocols_1.Protocols.Solend, hashes)
            .accounts({
            userSigner: program.user,
            vaultAccount: vaultKeys.vaultAccount,
        })
            .transaction();
    });
}
exports.setHashes = setHashes;
const refreshReserveIx = (tokenInput) => {
    const solendKeys = solendKeysAll[tokenInput];
    return refreshReserveInstruction(solendKeys.programId, solendKeys.reserveAccount, solendKeys.pythPriceOracleAccount, solendKeys.switchboardPriceFeedOracleAccount);
};
exports.refreshReserveIx = refreshReserveIx;
// https://github.com/solendprotocol/liquidator/blob/main/src/models/instructions/refreshReserve.ts
/// Accrue interest and update market price of liquidity on a reserve.
/// Accounts expected by this instruction:
///   0. `[writable]` Reserve account.
///   1. `[]` Clock sysvar.
///   2. `[optional]` Reserve liquidity oracle account.
///                     Required if the reserve currency is not the lending market quote
///                     currency.
const refreshReserveInstruction = (programId, reserve, oracle, switchboardFeedAddress) => {
    const dataLayout = buffer_layout_1.default.struct([buffer_layout_1.default.u8("instruction")]);
    const data = Buffer.alloc(dataLayout.span);
    dataLayout.encode({ instruction: refreshReserve }, data);
    const keys = [{ pubkey: reserve, isSigner: false, isWritable: true }];
    if (oracle) {
        keys.push({ pubkey: oracle, isSigner: false, isWritable: false });
    }
    if (switchboardFeedAddress) {
        keys.push({
            pubkey: switchboardFeedAddress,
            isSigner: false,
            isWritable: false,
        });
    }
    keys.push({
        pubkey: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
        isSigner: false,
        isWritable: false,
    });
    return new anchor_1.web3.TransactionInstruction({
        keys,
        programId,
        data,
    });
};
function deposit(program, genericAcccounts) {
    const tokenInput = program.tokenInput;
    const vaultKeys = program.vaultKeys[tokenInput];
    const solendKeys = solendKeysAll[tokenInput];
    return program.methods
        .solendDeposit()
        .accounts({
        genericAccs: genericAcccounts,
        solendProgramId: solendKeys.programId,
        vaultSolendCollateralTokenAccount: vaultKeys.vaultSolendCollateralTokenAccount,
        solendReserveAccount: solendKeys.reserveAccount,
        solendReserveLiquiditySupplySplTokenAccount: solendKeys.reserveLiquiditySupplySplTokenAccount,
        solendReserveCollateralSplTokenMint: solendKeys.reserveCollateralSplTokenMint,
        solendLendingMarketAccount: solendKeys.lendingMarketAccount,
        solendDerivedLendingMarketAuthority: solendKeys.derivedLendingMarketAuthority,
    })
        .preInstructions([(0, exports.refreshReserveIx)(tokenInput)])
        .transaction();
}
exports.deposit = deposit;
function withdraw(program, genericAcccounts) {
    return __awaiter(this, void 0, void 0, function* () {
        return withdrawBuilder(program, genericAcccounts).transaction();
    });
}
exports.withdraw = withdraw;
function withdrawBuilder(program, genericAcccounts) {
    const tokenInput = program.tokenInput;
    const vaultKeys = program.vaultKeys[tokenInput];
    const solendKeys = solendKeysAll[tokenInput];
    return program.methods
        .solendWithdraw()
        .accounts({
        genericAccs: genericAcccounts,
        solendProgramId: solendKeys.programId,
        vaultSolendCollateralTokenAccount: vaultKeys.vaultSolendCollateralTokenAccount,
        solendReserveAccount: solendKeys.reserveAccount,
        solendLendingMarketAccount: solendKeys.lendingMarketAccount,
        solendDerivedLendingMarketAuthority: solendKeys.derivedLendingMarketAuthority,
        solendReserveCollateralSplTokenMint: solendKeys.reserveCollateralSplTokenMint,
        solendReserveLiquiditySupplySplTokenAccount: solendKeys.reserveLiquiditySupplySplTokenAccount,
    })
        .preInstructions([(0, exports.refreshReserveIx)(tokenInput)]);
}
exports.withdrawBuilder = withdrawBuilder;
function tvl(program, genericAcccounts) {
    const tokenInput = program.tokenInput;
    const solendKeys = solendKeysAll[tokenInput];
    const vaultKeys = program.vaultKeys[tokenInput];
    return program.methods
        .solendTvl()
        .accounts({
        genericAccs: genericAcccounts,
        reserve: solendKeys.reserveAccount,
        vaultSolendCollateralTokenAccount: vaultKeys.vaultSolendCollateralTokenAccount,
    })
        .preInstructions([(0, exports.refreshReserveIx)(tokenInput)])
        .transaction();
}
exports.tvl = tvl;
//# sourceMappingURL=solend.js.map